/// <amd-module name="Repos/Artifact/Discussion/RestClient/Discussion" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\code-comments\discussion-by-artifact\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Discussion from "Repos/Artifact/Discussion/Contracts/Discussion";

export interface IDiscussionRestClient extends IVssRestClient {
    /**
     * Create a discussion comment POST /_apis/discussion/threads/\{discussionId\}/comments
     * 
     * @param newComment - 
     * @param discussionId - 
     */
    addComment(newComment: Discussion.DiscussionComment, discussionId: number): Promise<Discussion.DiscussionComment>;
    /**
     * Remove a discussion comment DELETE /_apis/discussion/threads/\{discussionId\}/comments/\{commentId\}
     * 
     * @param discussionId - 
     * @param commentId - 
     */
    deleteComment(discussionId: number, commentId: number): Promise<void>;
    /**
     * Update a discussion comment PATCH /_apis/discussion/threads/\{discussionId\}/comments/\{commentId\}
     * 
     * @param newComment - 
     * @param discussionId - 
     * @param commentId - 
     */
    updateComment(newComment: Discussion.DiscussionComment, discussionId: number, commentId: number): Promise<Discussion.DiscussionComment>;
    /**
     * Create a discussion thread POST /_apis/discussion/threads
     * 
     * @param newThread - 
     */
    createThread(newThread: Discussion.DiscussionThread): Promise<Discussion.DiscussionThread>;
    /**
     * Update a discussion thread PATCH /_apis/discussion/threads/\{discussionId\}
     * 
     * @param newThread - 
     * @param discussionId - 
     */
    updateThread(newThread: Discussion.DiscussionThread, discussionId: number): Promise<Discussion.DiscussionThread>;
}

class DiscussionRestClient extends RestClientBase implements IDiscussionRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Create a discussion comment POST /_apis/discussion/threads/\{discussionId\}/comments
     * 
     * @param newComment - 
     * @param discussionId - 
     */
    public async addComment(
        newComment: Discussion.DiscussionComment,
        discussionId: number
        ): Promise<Discussion.DiscussionComment> {

        return this.beginRequest<Discussion.DiscussionComment>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/discussion/threads/{discussionId}/Comments/{commentId}",
            routeValues: {
                discussionId: discussionId
            },
            body: newComment
        });
    }

    /**
     * Remove a discussion comment DELETE /_apis/discussion/threads/\{discussionId\}/comments/\{commentId\}
     * 
     * @param discussionId - 
     * @param commentId - 
     */
    public async deleteComment(
        discussionId: number,
        commentId: number
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/discussion/threads/{discussionId}/Comments/{commentId}",
            routeValues: {
                discussionId: discussionId,
                commentId: commentId
            }
        });
    }

    /**
     * Update a discussion comment PATCH /_apis/discussion/threads/\{discussionId\}/comments/\{commentId\}
     * 
     * @param newComment - 
     * @param discussionId - 
     * @param commentId - 
     */
    public async updateComment(
        newComment: Discussion.DiscussionComment,
        discussionId: number,
        commentId: number
        ): Promise<Discussion.DiscussionComment> {

        return this.beginRequest<Discussion.DiscussionComment>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/discussion/threads/{discussionId}/Comments/{commentId}",
            routeValues: {
                discussionId: discussionId,
                commentId: commentId
            },
            body: newComment
        });
    }

    /**
     * Create a discussion thread POST /_apis/discussion/threads
     * 
     * @param newThread - 
     */
    public async createThread(
        newThread: Discussion.DiscussionThread
        ): Promise<Discussion.DiscussionThread> {

        return this.beginRequest<Discussion.DiscussionThread>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/discussion/Threads",
            body: newThread
        });
    }

    /**
     * Update a discussion thread PATCH /_apis/discussion/threads/\{discussionId\}
     * 
     * @param newThread - 
     * @param discussionId - 
     */
    public async updateThread(
        newThread: Discussion.DiscussionThread,
        discussionId: number
        ): Promise<Discussion.DiscussionThread> {

        return this.beginRequest<Discussion.DiscussionThread>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/discussion/Threads/{discussionId}",
            routeValues: {
                discussionId: discussionId
            },
            body: newThread
        });
    }

}

export const DiscussionClientName = "Repos.Artifact.Discussion.IDiscussionRestClient";

export function getDiscussionClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IDiscussionRestClient {
    return pageContext.getRestClient<IDiscussionRestClient>(DiscussionClientName, options);
}

RestClients.add(DiscussionClientName, { 
    factory: DiscussionRestClient,
    options: {
        resourceAreaId: "6823169a-2419-4015-b2fd-6fd6f026ca00",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
